import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import Paginator from "react-ultimate-pagination-bootstrap-4";
import {
  getProductsTotalPages,
  getProductsCurrentPage,
  actions
} from "../modules/market";

const ProductPaginator = () => {
  const currentPage = useSelector(getProductsCurrentPage);
  const totalPages = useSelector(getProductsTotalPages);
  const dispatch = useDispatch();
  const onPageChange = useCallback(
    page => {
      dispatch(actions.setCurrentPage(page));
    },
    [dispatch]
  );
  return (
    <Paginator
      totalPages={totalPages}
      currentPage={currentPage}
      onChange={onPageChange}
    />
  );
};

export default ProductPaginator;
